import React, { useCallback } from "react";
import { RegisteredVehicle } from "common/graphql/fragments";
import { VehicleSelectionCardContent } from "./VehicleSelectionCardContent";

export interface VehicleSelectionCardProps {
  /** The vehicle to display */
  vehicle: RegisteredVehicle;
  /** Whether this vehicle is selected */
  isSelected: boolean;
  /** Whether selection is disabled (e.g., when "apply to all" is checked) */
  isDisabled?: boolean;
  /** Handler called when vehicle selection is toggled */
  onToggle: (vehicleId: string) => void;
}

/**
 * Container component for a selectable vehicle card.
 * Handles toggle logic and delegates rendering to VehicleSelectionCardContent.
 */
export const VehicleSelectionCard: React.FC<VehicleSelectionCardProps> = ({
  vehicle,
  isSelected,
  isDisabled = false,
  onToggle,
}) => {
  const handleToggle = useCallback(() => {
    if (!isDisabled) {
      onToggle(vehicle.id);
    }
  }, [vehicle.id, isDisabled, onToggle]);

  return (
    <VehicleSelectionCardContent
      vehicle={vehicle}
      isSelected={isSelected}
      isDisabled={isDisabled}
      onCardClick={handleToggle}
      onCheckboxChange={handleToggle}
    />
  );
};

export default VehicleSelectionCard;
